export default {
      id: "psd-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#psd",
      toString: function () {
        return this.url;
      }
    }